export default __webpack_public_path__ + "static/media/icon_data_download_btn.10b9fa42.svg";